export default function getCurrentScript() {
	const SCRIPT_ID = process.env.REACT_APP_SCRIPT_ID || '';

	return document.currentScript || document.getElementById(SCRIPT_ID);
}
